/**
 * Flattens a single-crash API record (`GET /crash/{id}`) into the flat shape used by the map popups.
 * @param {{ crash?: object, road?: object, units?: object[], people?: object[] }|undefined} crashRecord
 * @returns {object|null}
 */
export function toNotificationMapCrash(crashRecord) {
  if (!crashRecord?.crash) return null
  const { crash, road, units, people } = crashRecord
  return { ...crash, road: road ?? {}, units: units ?? [], people: people ?? [] }
}
